<template>
    <div class="container">
        <sidebar-container>
            <template v-slot:sidebar>
                <price-range></price-range>
            </template>
            <template v-slot:content>
                <div class="page-title">Лучшие товары</div>
                <div class="section best-products-cards">
                    <div class="card" v-for="card in cards">
                        <best-product-card :card="card"></best-product-card>
                    </div>
                    <pagination></pagination>
                </div>
            </template>
        </sidebar-container>
    </div>
</template>

<script>
    import BestProductCard from '../components/Cards/BestProductCard';
    import SidebarContainer from '../components/Containers/SidebarContentContainer';
    import Pagination from '../components/Pagination/Pagination';
    import PriceRange from '../components/Range/PriceRange';
    import BestProdSection from '../components/Sections/BestProdSection';
    export default {
        name: "BestProductsPage",
        components: { Pagination, PriceRange, BestProductCard, BestProdSection, SidebarContainer },
        data() {
            return {
                cards: [
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: 'new'
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '550',
                        amount: '896',
                        status: 'sale'
                    },
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: 'new'
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '600',
                        amount: '896',
                        status: 'sale'
                    },
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '89',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '390',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '390',
                        amount: '896',
                        status: ''
                    },
                ]
            }
        }
    };
</script>

<style scoped lang="scss">
    .best-products {
        &-cards {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
</style>
